import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLines } from "@/components/motion/MaskedLines";
import { ProductGrid } from "@/components/shop/ProductGrid";

export const Collection = () => (
  <section id="collezione" className="bg-ivory py-24 lg:py-36" data-testid="collection-section">
    <div className="container-pf">
      <div className="mb-12 grid gap-6 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <p className="eyebrow">La collezione</p>
          <h2 className="mt-5 font-display text-4xl font-medium leading-[1.02] text-navy sm:text-5xl lg:text-6xl">
            <MaskedLines lines={["Dieci gesti di cura,", <em className="italic text-copper">una sola linea.</em>]} />
          </h2>
        </div>
        <div className="lg:col-span-4 lg:col-start-9">
          <p className="text-lg leading-relaxed text-slate2">Dalla detersione al trattamento, fino all'igiene intima e all'incontinenza: tutto ciò che serve alla pelle matura, in un'unica linea coerente.</p>
          <Link to="/collezione" className="link-underline mt-5 inline-flex items-center gap-2 text-[16px] font-medium text-navy" data-testid="collection-see-all">
            Vedi tutta la collezione <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
      <ProductGrid />
    </div>
  </section>
);
